<!-- File: CeilingSetup.vue -->
<template>
    <v-card class="mt-2">
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-text-field
                        v-model="setup.area"
                        label="Suprafață totală (m²)"
                        type="number"
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        clearable
                        :min="1"
                        :rules="[
                            (value) =>
                                !value ||
                                value > 0 ||
                                'Valoarea trebuie să fie mai mare decât 0',
                        ]"
                    />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                        v-model="setup.floors"
                        label="Nr. etaje"
                        type="number"
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        clearable
                        :min="1"
                        :rules="[
                            (value) =>
                                !value ||
                                value > 0 ||
                                'Valoarea trebuie să fie mai mare decât 0',
                        ]"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "CeilingSetup",
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    computed: {
        setup: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>
